import React from 'react';
import { Text, DesktopWrap, UnsavedChangesDiv } from './Notifications.styled';
import Popup from 'src/common/refactoredComponents/popup/Popup';
import AlertCircleOutline from 'src/assets/images/AlertCircleOutline.svg';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import { useTranslation } from 'react-i18next';

const UnsavedChanges = ({
    onClose,
    onDiscard,
    continueText,
    fromSettingsClose,
}) => {
    const { t: translation } = useTranslation();
    return (
        <>
            <Popup
                id="receivesets-unsavedchanges-popup"
                title={translation('equity.unsavedChanges.title')}
                onClose={fromSettingsClose ? fromSettingsClose : onClose}
                img={AlertCircleOutline}
                isUnsavedPage={true}
            >
                <UnsavedChangesDiv divHeight={'140px'}>
                    <Text
                        flexGrow={'1'}
                        height={'auto'}
                        font={'14px Avenir Next World'}
                        lineHeight={'20px'}
                    >
                        {translation('equity.unsavedChanges.warningMessage')}
                    </Text>
                    <DesktopWrap flexDirection="row-reverse">
                        <Button
                            id={'receiveSets-notifications-continueButton'}
                            show={true}
                            width={'308px'}
                            height={'38px'}
                            //primary={true}
                            variant={ButtonStyles?.primary}
                            // borderRadius={'19px'}
                            margin={'5px 0 5px 5px'}
                            // fontSize={'15px'}
                            // fontFamily={'AvenirNextWorld Demi'}
                            clicked={onClose}
                        >
                            <div style={{ whiteSpace: 'nowrap' }}>
                                {continueText
                                    ? continueText
                                    : translation(
                                          'equity.unsavedChanges.continueEditingBtn'
                                      )}
                            </div>
                        </Button>

                        <Button
                        id={'receiveSets-notifications-discardButton'}
                            show={true}
                            //discard={true}
                            variant={ButtonStyles?.discard}
                            width={'308px'}
                            height={'38px'}
                            // borderRadius={'19px'}
                            margin={'5px 0 5px 5px'}
                            // fontSize={'15px'}
                            // fontFamily={'AvenirNextWorld Demi'}
                            clicked={onDiscard}
                        >
                            <div style={{ whiteSpace: 'nowrap' }}>
                                {translation('receiveSets.ReceiveSetsLoc.AddSetsLists.discardChanges')}
                            </div>
                        </Button>
                    </DesktopWrap>
                </UnsavedChangesDiv>
            </Popup>
        </>
    );
};

export default UnsavedChanges;
